import { SSO } from "../../common/apiUrl/sso/ssoUrl";
import { API } from "../../common/model/objectTypes";
import { organizerInProcessInfo } from "../../utils/apiDescription/sso/inProcess";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader, commonResponseBody, createCommonJsonResponseWithData, requestHeaderWithCallback } from "../../utils/objectTypeConstants";
import { inProcessOrganizersRequestParameter, inProcessOrganizersResponseBody, organizerDeleteInProcessRequestBody } from "../../utils/sso/apiObjects";
import { deleteInProcessOrganizerJsonRequestCurl, inProcessOrganizersJsonRequestCurl } from "../../utils/sso/sampleJsonRequest";
import { inProcessOrganizersJsonResponse } from "../../utils/sso/sampleJsonResponse";

const deleteInProcessOrganizer: API = {
    name: "Delete In Process Organizer",
    url: `${API_BASE_URL}/${SSO.IN_PROCESS.DELETE_IN_PROCESS_ORGANIZER_URL}`,
    method: "DEL",
    headers: requestHeaderWithCallback,
    apiInfo: organizerInProcessInfo.deleteInProcessOrganizer,
    requestBody: organizerDeleteInProcessRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: deleteInProcessOrganizerJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

const inProcessOrganizers: API = {
    name: "In Process Organizers",
    url: `${API_BASE_URL}/${SSO.IN_PROCESS.IN_PROCESS_ORGANIZERS_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: organizerInProcessInfo.inProcessOrganizers,
    requestBody: inProcessOrganizersRequestParameter,
    responseBody: inProcessOrganizersResponseBody,
    jsonRequest: inProcessOrganizersJsonRequestCurl,
    jsonResponse: inProcessOrganizersJsonResponse,
}

export const getContent = (apiName: string) => {
    switch (apiName) {
        case 'Delete In Process Organizer':
            return deleteInProcessOrganizer;
        case 'All':
            return inProcessOrganizers;
    }
}